export const GUESTBOOK_NAME_MAX_LENGTH = 80;
export const GUESTBOOK_MESSAGE_MAX_LENGTH = 700;

export type GuestbookStatus = "visible" | "hidden";
